import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBookingItineraryPresComponent } from './my-booking-itinerary-pres.component';
import { FareRulesModule } from '../sub-components/fare-rules/fare-rules.module';
import { StaticMsgModule } from '@lib/pipes';
import { MyBookingPaymentModule } from '../sub-components/my-booking-payment/my-booking-payment.module';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { TripSummaryModule } from '../sub-components/trip-summary/trip-summary.module';
import { BaggageRulesModule } from '../sub-components/baggage-rules/baggage-rules.module';

@NgModule({
  declarations: [MyBookingItineraryPresComponent],
  imports: [
    CommonModule,
    BaggageRulesModule,
    FareRulesModule,
    MyBookingPaymentModule,
    StaticMsgModule,
    TripSummaryModule,
  ],
  exports: [MyBookingItineraryPresComponent],
  providers: [MyBookingItineraryService],
})
export class MyBookingItineraryPresModule {}
